import classNames from 'classnames';
import * as React from 'react';
import { isLinkListWithTabs, isPlainLinkList } from '~/Partials/LinkListSection/Utils/LinkListSectionUtils';
import { assertNever } from '~/Partials/Utils/typeUtils';
import { LinkListSectionPlainContent } from './Components/LinkListSectionPlainContent';
import { LinkListSectionTabsContent } from './Components/LinkListSectionTabsContent/LinkListSectionTabsContent';
import styles from './LinkListSection.module.css';
import type { LinkListSectionPlainViewModel } from './ViewModel/LinkListSectionPlainViewModel.csharp';
import type { LinkListSectionWithTabsViewModel } from './ViewModel/LinkListSectionWithTabsViewModel.csharp';

type LinkListSectionViewModel = LinkListSectionWithTabsViewModel | LinkListSectionPlainViewModel;

export const LinkListSection: React.FC<React.PropsWithChildren<LinkListSectionViewModel>> = props => {
    const { variant, columnsLayout } = props;

    const getLinkListContent = () => {
        if (isPlainLinkList(props)) {
            return <LinkListSectionPlainContent {...props} />;
        }

        if (isLinkListWithTabs(props)) {
            return <LinkListSectionTabsContent {...props} />;
        }

        assertNever(props);
    };

    return (
        <div
            className={classNames(
                styles.LinkListSection,
                styles[`Variant--${variant}`],
                columnsLayout === 'single' && styles[`Variant--${columnsLayout}`]
            )}
        >
            <div className={styles.Inner}>{getLinkListContent()}</div>
        </div>
    );
};
